<template>
  <div>
    <div class="type-input" :class="{'has-error': !isTypeDirty && !['public', 'private'].includes(model.type)}">
      <label>Type de centre de santé</label>
      <div class="options">
        <span class="option" :class="{'is-selected': model.type === 'public'}" @click="setHospitalType('public')">Public</span>
        <span class="option" :class="{'is-selected': model.type === 'private'}" @click="setHospitalType('private')">Privé</span>
      </div>
    </div>

    <material-input
      label="Nom du Centre de santé"
      v-model.trim="model.name"
      v-validate="'required|unique_hospital:name,Ce nom est déjà pris'"
      data-vv-name="name"
      data-vv-as="Le nom"
      :error="errors.first('name')" />

    <material-input
      label="Localisation du Centre de santé"
      v-model.trim="model.address"
      v-validate="'required'"
      data-vv-name="address"
      data-vv-as="L'adresse"
      :error="errors.first('address')"
      placeholder="Ex: Cotonou, Bénin" />

    <div class="fullPhone">
      <material-select class="prefix"
        v-model="model.countryCode"
        :label="'+' + countryPrefix"
        :options="prefixes" />

      <material-input class="phone"
        type="tel"
        label="Numéro de téléphone principal"
        v-model.trim="model.contact"
        v-validate="'required|regex:^([0-9]{2} ?){4}$|unique_hospital:contact,Ce numéro de téléphone est déjà pris'"
        data-vv-name="contact"
        data-vv-as="Le contact"
        :error="errors.first('contact')"
        :placeholder="phonePlaceholder" />
    </div>

    <material-input type="email"
      label="Adresse e-mail principale"
      v-model.trim="model.email"
      v-validate="'required|email|unique_hospital:email,Cette adresse e-mail est déja prise'"
      data-vv-name="email"
      data-vv-as="L'adresse e-mail"
      :error="errors.first('email')" />

    <material-input
      type="domain"
      label="Identifiant goMediCAL"
      prefix="https://"
      suffix=".gomedical.io"
      placeholder="Ceci est l'adresse de votre agenda"
      v-model.trim="model.subdomain"
      v-validate="'required|unique_hospital:subdomain,Ce identifiant est déjà pris'"
      data-vv-name="subdomain"
      data-vv-as="Le domaine"
      :error="errors.first('subdomain')" />

  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import slugify from 'slugify'
import MaterialInput from '@/components/MaterialInput'
import MaterialSelect from '@/components/MaterialSelect'

export default {
  components: {
    MaterialInput,
    MaterialSelect
  },

  data () {
    return {
      model: null,
      isTypeDirty: true,
      prefixes: [{
        value: '221',
        text: 'Sénégal (+221)',
        shortText: '+221'
      }, {
        value: '229',
        text: 'Bénin (+229)',
        shortText: '+229'
      }]
    }
  },

  computed: {
    ...mapGetters(['hospital', 'countryPrefix']),

    domainPlaceholder () {
      return ``
    },

    phonePlaceholder () {
      return this.countryPrefix === '229'
        ? '97970000'
        : '77000000'
    }
  },

  watch: {
    'model.name' (val) {
      this.model.subdomain = slugify(val.toLowerCase())
    },

    model: {
      deep: true,
      handler (model) {
        this.setHospital(model)
      }
    }
  },

  beforeMount () {
    this.model = {...this.hospital}
  },

  methods: {
    ...mapActions(['setHospital']),

    setHospitalType (type) {
      this.isTypeDirty = false
      this.model.type = type
    },

    async validate () {
      this.isTypeDirty = false

      try {
        const valid = await this.$validator.validateAll() && ['public', 'private'].includes(this.model.type)
        console.log('valid', valid)
        return valid
      } catch (error) {
        console.log('error', error)
        return false
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../../assets/sass/variables.scss';

  .fullPhone {
    position: relative;
  }

  .prefix {
    width: 100px !important;
    position: absolute !important;
  }

  .phone {
    margin-left: 55px;
  }

  .value {
    cursor: pointer;
  }

  .type-input {
    margin-bottom: 3.5rem;

    label {
      font-size: 1.8rem;
      color: #4d4d4d;
    }

    &.has-error label {
      color: red;
    }

    .options {
      margin-top: 0.5rem;

      .option {
        display: inline-block;
        border: 2px solid #e4ebf3;
        padding: 0.5rem 1rem;
        border-radius: 0.5rem;
        min-width: 20rem;
        font-size: 1.8rem;
        color: #4d4d4d;
        text-align: center;
        cursor: pointer;

        &:not(:last-child) {
          margin-right: 2rem;
        }

        &.is-selected {
          border-color: $color-primary;
          background: $color-primary;
          color: #fff;
        }

        @media screen and (max-width: $mobile-breakpoint) {
          min-width: calc(50% - 57px);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/register/step1.vue